import { Component, Input, OnChanges, OnInit, Output, EventEmitter } from '@angular/core';
import { FeesService } from '../../../fees.service';
import { StorageUtil, Store, AppState, AppFields, AutoUnsubscribe, Subscription } from '../../../store';
import { TryoutMemberService } from '../../../services/tryout_Services/tryout-member.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AlertService } from '../../../services/alert.service';
import { MyTeamsService } from '../../../services';

@Component({
  selector: 'app-tryout-assign-team',
  templateUrl: './tryout-assign-team.component.html',
  styleUrls: ['./tryout-assign-team.component.css']
})
@AutoUnsubscribe
export class TryoutAssignTeamComponent implements OnInit {

  @Input() members = [];
  @Output() close = new EventEmitter();

  sub: Subscription;
  _teams = [];

  constructor(
    private feeService: FeesService,
    private store: Store<AppState>,
    private service: TryoutMemberService,
    public teamService: MyTeamsService,
    private spinner: Ng4LoadingSpinnerService,
    private as: AlertService
  ) { }

  ngOnInit() {
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe((team) => {
      this.sub = this.store.select(AppFields.App, AppFields.Program).subscribe(c => {
        if (team && c && c.clubID) {
          this.teamService.getAdminTeamList(StorageUtil.userID, -1).subscribe(teams => {
            this._teams = teams.filter(t => t.clubID === c.clubID);
          }, (error) => {
            console.log(error.error);
          });
        } else if (c && c.clubID) {
          this.feeService.getFeeTeams('b', String(c.clubID)).subscribe(teams => {
            this._teams = teams;
          });
        }
      });
    });
  }

  onClose(event) {
    event.preventDefault();
    this.clearCheckboxes();
    this.close.emit(false);
  }

  clearCheckboxes() {
    this.teams.forEach(t => t.checked = false);
  }

  onAssign(event) {
    event.preventDefault();
    this.spinner.show();
    this.service.assignMembersToTeams(this.members.map(m => m.userID), this.checkedTeams).subscribe(
      () => {
        this.spinner.hide();
        this.as.success('Success!');
        this.close.emit(true);
      },
      () => {
        this.spinner.hide();
        this.as.error('Something went wrong');
      }
    );
  }

  get gender(): string {
    const genders = this.members.map(member => member.gender[0].toLowerCase());
    const m = genders.indexOf('m') > -1;
    const f = genders.indexOf('f') > -1;

    return !m ? 'f' : !f ? 'm' : 'b';
  }

  get teams() {
    return this.gender === 'b' ? this._teams.slice() : this._teams.filter(t => t.gender.toLowerCase() === this.gender);
  }

  get checkedTeams() {
    return this.teams.filter(x => x.checked).map(t => t.teamID);
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-assign-team/tryout-assign-team.component.ts